module.exports = __webpack_public_path__ + "media/src/public/images/mail/pretty/team-1ce49081d4411459a51eef147b25b074.png";